import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=ffd579e2&scoped=true&"
import script from "./ProductImage.vue?vue&type=script&lang=js&"
export * from "./ProductImage.vue?vue&type=script&lang=js&"
import style0 from "./ProductImage.vue?vue&type=style&index=0&id=ffd579e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd579e2",
  null
  
)

export default component.exports